<template>
    <div id="PriceTrackingCompare">
        <div data-html2canvas-ignore="true" class="customdim"
            v-show="loader || loader0 || loaderPinList || getProductsLoader || primaryProductLoader || secondaryProductLoader || loderForDynamicData || saveViewGetLoader">
            <!-- <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div> -->
            <Loader />
        </div>
        <!-- filters -->
        <div class="datepickerwrap card">
            <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex" style="width:90%">
                    <!-- date range -->
                    <div style="min-width: 100px;" class="mr-2">
                        <div class="mb-1 ml-1" style="font-size:14px; font-weight:400; color:#1E1E1E">Date Range</div>
                        <date-range-picker v-model="dateRange" :show-dropdowns="true" opens='right' :autoApply="true"
                            :locale-data="{ format: 'dd mmm yyyy' }" :single-date-picker="false" :min-date="minDate"
                            :max-date="maxDate">
                        </date-range-picker>
                    </div>
                    <!-- <div class="customSelect mx-0">
                        <div class="mb-1 ml-1" style="font-size:14px; font-weight:400; color:#1E1E1E">Platform</div>
                        <select v-model="selectedPlatform" class="form-control text-uppercase">
                            <option value="">All Platforms</option>
                            <option v-for="(d, i) in platformColor" :value="i" :key="i">
                                {{ i.replace("_", " ") }}
                            </option>
                        </select>
                    </div> -->
                    <!-- platform filter -->
                    <div class="custom_dropdown customMultiselect" style="min-width: 220px ; max-width:310px">
                        <div class="mb-1 ml-1"
                            style="font-size:14px; font-weight:400; color:#1E1E1E;  font-family: 'Poppins'">Platforms
                        </div>
                        <multiselect v-model="selectedPlatform" :options="storeAllPlatformsForMultipleSelection"
                            :multiple="true" :searchable="false" placeholder="Select Platform" selectLabel=""
                            deselectLabel="Remove" :close-on-select="false" @input="changeSelectInput" class="customSelectedLabels text-capitalize">
                            <template slot="beforeList">
                                <div class="d-flex align-items-center py-2 px-1 allSelect"
                                    @click="selectPlatformsForAllList">
                                    <input type="checkbox" class="mx-2" v-model="allPlaformSelectedBoolean" />
                                    <span class="ml-2">All</span>
                                </div>
                            </template>
                            <template slot="option" slot-scope="{ option }" class="text-capitalize">
                                <input type="checkbox" :value="option" v-model="selectedPlatform">
                                <span class="option__title ml-3 text-capitalize">{{ option.replaceAll("_", " ") }}</span>
                            </template>
                            <template slot="tag" slot-scope="{ option, remove }">
                                <span class="custom-tag d-flex align-items-center">
                                    {{ option.replaceAll("_", " ") }}
                                    <span class="remove-icon ml-0 pl-2 pr-2" @click="remove(option)">×</span>
                                </span>
                            </template>
                        </multiselect>
                    </div>
                    <!-- category filter -->
                    <div class="customSelect" v-if="isSegment">
                        <div class="mb-1 ml-1" style="font-size:14px; font-weight:400; color:#1E1E1E">Category</div>
                        <select v-model="segmentDropdown.selectedSegment" class="form-control text-capitalize"
                            @change="changedCategorty">
                            <option value="" class="text-capitalize">All Categories</option>
                            <option v-for="d in segmentDropdown.options" :value="d" :key="d" class="text-capitalize">
                                {{ d.replace("_", " ") }}
                            </option>
                        </select>
                    </div>
                    <!-- pincode -->
                    <div class="customMultiselect ml-0" style="max-width: 10%;" v-if="locationDropdown.options.length">
                        <div class="mb-1 ml-1" style="font-size:14px; font-weight:400; color:#1E1E1E">Pincode</div>
                        <treeselect v-model="locationDropdown.checkSelectedPins" :options="locationDropdown.options"
                            value-consists-of="LEAF_PRIORITY" :disable-branch-nodes="true" placeholder="Select PIN"
                            :multiple="false" :searchable="true">
                            <span slot="noResult">Oops! No elements found. Consider changing the search query.</span>
                        </treeselect>
                    </div>
                    <!-- filter button -->
                    <div class="d-flex align-items-end mb-1 ml-3" @click="applyFilterForCompare">
                        <button class="btn primarycolor mr-3">
                            Apply Filters
                        </button>
                    </div>
                </div>
                <div @click="goBack" style="text-decoration: none; float: right">
                    <button style="width: max-content; float: right" class="btn navigationButton" type="button">
                        <i class="fa fa-arrow-left mr-1"></i>
                        <span style="font-size: 13px">Back</span>
                    </button>
                </div>

                <!-- <div class="d-flex justify-content-end align-items-center">
                    <button class="btn insights">
                        insights
                    </button>
                </div> -->
                <!-- <div class="d-flex justify-content-end align-items-center">
                    <button class="btn saveViewBtn" :disabled="saveViewPostLoader" @click="savedViewPostApiCall">
                        <b-spinner small class="mr-2" v-if="saveViewPostLoader"></b-spinner>
                        <span>Save View</span>
                    </button>
                </div> -->
            </div>
        </div>

        <div class="revampCard">
            <div class="card">
                <div class="d-flex justify-content-between align-items-center">
                    <div class="d-flex justify-content-start">
                        <div class="graphHeading pb-2 mr-3">{{ viewNameCollection.selectedViewName }}</div>
                        <div class="viewNameEditBtn" v-if="viewNameCollection.selectedViewName"
                            @click="changeViewNameByPencil(viewNameCollection.selectedViewName)">
                            <img src="../../../public/Icons_SVG/editBtn.svg" style="width: 15px; height: 15px;" />
                        </div>
                        <div class="viewNameEditBtn ml-3" v-if="viewNameCollection.selectedViewName"
                            @click="showViewDeleteModal">
                            <img src="../../../public/Icons_SVG/deleteBtnSvg.svg" style="width: 15px; height: 15px;" />
                        </div>
                    </div>
                    <div class="d-flex justify-content-end align-items-end">
                        <div class="customSelect">
                            <div class="mb-1 ml-1" style="font-size:14px; font-weight:400; color:#1E1E1E">Select View
                                Name</div>
                            <select @change="handleViewSelection" v-model="viewNameCollection.selectedViewName"
                                class="form-control text-capitalize">
                                <option value="" disabled hidden class="text-capitalize">choose One</option>
                                <option v-for="d in viewNameCollection.options" :value="d" :key="d" class="text-capitalize">
                                    {{ d }}
                                </option>
                            </select>
                        </div>
                        <!-- <div class="d-flex align-items-end">
                            <button class="btn primarycolor mr-3">
                                Apply Filters
                            </button>
                        </div> -->
                        <div class="d-flex align-items-end">
                            <button @click="addNewComparisonFun(true)"
                                class="btn primarycolor mr-2 d-flex item-items-center">
                                <span class="newComparisonIcon">
                                    <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                        <path
                                            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z">
                                        </path>
                                    </svg>
                                </span>
                                <span>Add New View</span>
                            </button>
                        </div>
                        <div class="d-flex justify-content-end align-items-center">
                            <button class="btn saveViewBtn" @click="showModalForSaveViewFun">
                                <span>Save View</span>
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </div>


        <!-- new -->
        <div class="">
            <div v-for="(compareData, cardIndex) in dynamicCompareCards"
                class="position-relative p-4 card revampCard compare-container-data-price mb-4">
                <div
                    :class="[compareData.primaryProductInfo.selectedPrimaryProduct !== null && compareData.secondaryProductInfo[0].selectedSecondaryProduct !== null ? 'card' : '']">
                    <div class="d-flex">
                        <div v-if="checkSecondaryProductLength(compareData.primaryProductInfo.selectedPrimaryProduct, compareData.secondaryProductInfo[0].selectedSecondaryProduct)"
                            class="px-0 fixed-position point-compare pb-0"
                            style="width: 14% !important; box-shadow: 4px 0px 7.1px 0px #0000001A !important;">
                            <h2 class="bgTopColor mb-0"></h2>
                            <div class="product-image points-highlighted border-bottom d-flex align-items-start pt-3 pl-3"
                                style="height: 11.6rem;">
                                Product Description
                            </div>
                            <!-- <p class="product-name"></p> -->
                            <div class="quality-score border-bottom points-highlighted d-flex align-items-start pt-3 pl-3"
                                style="height: 23.6rem;">
                                Price Mapping
                            </div>
                            <div class="quality-score points-highlighted d-flex align-items-start pt-3 pl-3">
                                Offers
                            </div>
                            <!-- <div class="quality-score border-bottom points-highlighted d-flex align-items-center pl-4"
                                style="height: 22.6rem;">
                                Patner Offers
                            </div>
                            <div class="quality-score border-bottom points-highlighted d-flex align-items-center pl-4"
                                style="height: 22.6rem;">
                                Other Offers
                            </div> -->
                            <!-- <div class="border-bottom">
                                <div class="copy-breakdown points-highlighted pl-4">Copy Breakdown</div>

                            </div>

                            <div class="border-bottom">
                                <div class="media-breakdown points-highlighted pl-4">Media Breakdown</div>

                            </div>

                            <div class="border-bottom">
                                <div class="review-breakdown points-highlighted pl-4">Review Breakdown</div>

                            </div>
                            <div style="height: 50px;"></div> -->
                        </div>
                        <div
                            :class="[compareData.primaryProductInfo.selectedPrimaryProduct !== null && compareData.secondaryProductInfo[0].selectedSecondaryProduct !== null ? 'scroll-container col-sm-10-width position-relative pl-2' : 'col-sm-12-width mt-3 p-0']">
                            <!-- <h2 class="bgTopColor mb-0">Product{{ index+1}}</h2> -->
                            <div class="row position-relative compareContainerCards">
                                <div class="col-6 pr-3 pl-2">
                                    <h2 style="margin: 0 -16px;" class="bgTopColor mb-3"
                                        v-if="checkSecondaryProductLength(compareData.primaryProductInfo.selectedPrimaryProduct, compareData.secondaryProductInfo[0].selectedSecondaryProduct)">
                                        Product 1</h2>
                                    <div class="mb-0">
                                        <div v-if="compareData.primaryProductInfo.noDataMessage == null">
                                            <div class="mb-0"
                                                v-if="storeProductDropdown.options.length && compareData.primaryProductInfo.data.length">
                                                <CompareProductWithChart
                                                    :showHeading="checkSecondaryProductLength(compareData.primaryProductInfo.selectedPrimaryProduct, compareData.secondaryProductInfo[0].selectedSecondaryProduct)"
                                                    :productSelectSku="compareData.primaryProductInfo.selectedPrimaryProduct"
                                                    :productDropdown="storeProductDropdown.options"
                                                    :getProductDataOnChangeInput="(sku) => getDyamicProductDataOnChangeInput(sku, cardIndex, null, 'primary')"
                                                    :productType='compareData.primaryProductInfo.typeOfProduct'
                                                    :productImage="compareData.primaryProductInfo.data[compareData.primaryProductInfo.data.length - 1].product_image"
                                                    :storeProductInfo="compareData.primaryProductInfo"
                                                    :productOffers="compareData.primaryProductInfo.productOffers" />
                                            </div>
                                            <div v-if="!compareData.primaryProductInfo.data.length"
                                                class="addNewBrand py-5 d-flex justify-content-center">
                                                <div @click="toggleProductSelectionDropdown(cardIndex, null, 'primary')"
                                                    class="d-flex align-items-center justidy-content-center"
                                                    style="cursor: pointer;">
                                                    <div class="plus-icon">
                                                        +
                                                    </div>
                                                    <div class="ml-3" style="font-size:16px; font-weight: 500;">
                                                        Add Product
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="customMultiselect ml-0 mt-3"
                                                v-if="storeProductDropdown.options.length && compareData.primaryProductInfo.showProductDropdownPrimary">
                                                <div class="mb-1 ml-1"
                                                    style="font-size:14px; font-weight:400; color:#1E1E1E">
                                                    Product
                                                    Name
                                                </div>
                                                <treeselect
                                                    v-model="compareData.primaryProductInfo.selectedPrimaryProduct"
                                                    :show-count="true"
                                                    @select="(sku) => getDyamicProductDataOnChangeInput(sku, cardIndex, null, 'primary')"
                                                    :options="storeProductDropdown.options"
                                                    value-consists-of="LEAF_PRIORITY" :disable-branch-nodes="true"
                                                    placeholder="Select Product Name" :searchable="true">
                                                    <span slot="noResult">Oops! No elements found. Consider changing the
                                                        search
                                                        query.</span>
                                                </treeselect>
                                            </div>
                                            <div v-if="storeProductDropdown.options.length === 0 && compareData.primaryProductInfo.showProductDropdownPrimary"
                                                class="text-danger mt-2">
                                                Oops! No products available for this category. Kindly select another
                                                category.
                                            </div>
                                        </div>
                                        <div v-else
                                            class="text-danger d-flex justify-content-center border border-danger rounded p-2 noData">
                                            {{
                                                compareData.primaryProductInfo.noDataMessage }}</div>
                                    </div>
                                </div>
                                <div class="pr-0 pl-0 d-flex"
                                    :class="[getSecondaryItemWidthClass(compareData.secondaryProductInfo.length)]">
                                    <div v-for="(secondaryItems, secondaryItemsIndex) in compareData.secondaryProductInfo"
                                        class="pl-0 pr-3"
                                        :class="[(secondaryItemsIndex == 0 && secondaryItems.selectedSecondaryProduct == null) || !checkSecondaryProductLength(compareData.primaryProductInfo.selectedPrimaryProduct, compareData.secondaryProductInfo[0].selectedSecondaryProduct) ? 'col-12' : 'col-11']">
                                        <h2 style="margin: 0 -16px 0 0;" class="bgTopColor mb-3"
                                            v-if="checkSecondaryProductLength(compareData.primaryProductInfo.selectedPrimaryProduct, compareData.secondaryProductInfo[0].selectedSecondaryProduct)">
                                            Product {{ secondaryItemsIndex + 2 }}</h2>
                                        <div class="mb-3">
                                            <div class="position-relative" v-if="secondaryItems.noDataMessage == null">
                                                <div
                                                    v-if="storeProductDropdown.options.length && secondaryItems.data.length">
                                                    <CompareProductWithChart
                                                        :showHeading="checkSecondaryProductLength(compareData.primaryProductInfo.selectedPrimaryProduct, compareData.secondaryProductInfo[0].selectedSecondaryProduct)"
                                                        :productSelectSku="secondaryItems.selectedSecondaryProduct"
                                                        :productDropdown="storeProductDropdown.options"
                                                        :getProductDataOnChangeInput="(sku) => getDyamicProductDataOnChangeInput(sku, cardIndex, secondaryItemsIndex, 'secondary')"
                                                        :productType='secondaryItems.typeOfProduct'
                                                        :productImage="secondaryItems.data[secondaryItems.data.length - 1].product_image"
                                                        :storeProductInfo="secondaryItems"
                                                        :productOffers="secondaryItems.productOffers" />
                                                </div>
                                                <div v-if="!secondaryItems.data.length"
                                                    class="addNewBrand py-5 d-flex justify-content-center">
                                                    <div @click="toggleProductSelectionDropdown(cardIndex, secondaryItemsIndex, 'secondary')"
                                                        class="d-flex align-items-center justidy-content-center"
                                                        style="cursor: pointer;">
                                                        <div class="plus-icon">
                                                            +
                                                        </div>
                                                        <div class="ml-3" style="font-size:16px; font-weight: 500;">
                                                            Add Product
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="customMultiselect ml-0 mt-3"
                                                    v-if="storeProductDropdown.options.length && secondaryItems.showProductDropdownSecondary">
                                                    <div class="mb-1 ml-1"
                                                        style="font-size:14px; font-weight:400; color:#1E1E1E">
                                                        Product
                                                        Name
                                                    </div>
                                                    <treeselect v-model="secondaryItems.selectedSecondaryProduct"
                                                        :show-count="true"
                                                        @select="(sku) => getDyamicProductDataOnChangeInput(sku, cardIndex, secondaryItemsIndex, 'secondary')"
                                                        :options="storeProductDropdown.options"
                                                        value-consists-of="LEAF_PRIORITY" :disable-branch-nodes="true"
                                                        placeholder="Select Product Name" :searchable="true">
                                                        <span slot="noResult">Oops! No elements found. Consider changing
                                                            the
                                                            search
                                                            query.</span>
                                                    </treeselect>
                                                </div>
                                                <div v-if="storeProductDropdown.options.length === 0 && secondaryItems.showProductDropdownSecondary"
                                                    class="text-danger mt-2">
                                                    Oops! No products available for this category. Kindly select another
                                                    category.
                                                </div>
                                                <div v-if="checkShowAndHide(secondaryItemsIndex)"
                                                    class="removeDynamicSeconadyCardBtn position-absolute"
                                                    @click="removeDyamicCardFun(cardIndex, secondaryItemsIndex, 'secondary')">
                                                    +
                                                </div>
                                            </div>
                                            <div v-else
                                                class="text-danger d-flex justify-content-center border border-danger rounded p-2 noData">
                                                {{
                                                    secondaryItems.noDataMessage }}</div>
                                        </div>

                                    </div>
                                    <div v-if="checkLengthOfDynamicCards('secondarySubArray', cardIndex) && checkSecondaryProductLength(compareData.primaryProductInfo.selectedPrimaryProduct, compareData.secondaryProductInfo[0].selectedSecondaryProduct)"
                                        class="addMoreProductCompareIcon d-flex align-items-center justify-content-between flex-column mx-1"
                                        @click="addMoreDynamicSecondaryItemsFun(cardIndex)">
                                        <h2 style="margin: 0 -14px 0 0; width: 146%;" class="bgTopColor mb-3"></h2>
                                        <div class="plus-icon">
                                            +
                                        </div>
                                        <p></p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div v-if="checkShowAndHide(cardIndex)" class="removeDynamicCardBtn position-absolute"
                    @click="removeDyamicCardFun(cardIndex, null, 'primary')">
                    +
                </div>
            </div>
        </div>



        <!-- dynamic product comparison cards -->
        <!-- <div v-for="(compareData, cardIndex) in dynamicCompareCards" class="position-relative revampCard">
            <div class="card">
                <div class="row position-relative compareContainerCards">
                    <div class="col-6 pr-3 pl-2">
                        <div class="mb-0">
                            <div v-if="compareData.primaryProductInfo.noDataMessage == null">
                                <div class="mb-0"
                                    v-if="storeProductDropdown.options.length && compareData.primaryProductInfo.data.length">
                                    <CompareProductWithChart
                                        :productSelectSku="compareData.primaryProductInfo.selectedPrimaryProduct"
                                        :productDropdown="storeProductDropdown.options"
                                        :getProductDataOnChangeInput="(sku) => getDyamicProductDataOnChangeInput(sku, cardIndex, null, 'primary')"
                                        :productType='compareData.primaryProductInfo.typeOfProduct'
                                        :productImage="compareData.primaryProductInfo.data[compareData.primaryProductInfo.data.length - 1].product_image"
                                        :storeProductInfo="compareData.primaryProductInfo" />
                                </div>
                                <div v-if="!compareData.primaryProductInfo.data.length"
                                    class="addNewBrand py-5 d-flex justify-content-center">
                                    <div @click="toggleProductSelectionDropdown(cardIndex, null, 'primary')"
                                        class="d-flex align-items-center justidy-content-center"
                                        style="cursor: pointer;">
                                        <div class="plus-icon">
                                            +
                                        </div>
                                        <div class="ml-3" style="font-size:16px; font-weight: 500;">
                                            Add Product
                                        </div>
                                    </div>
                                </div>
                                <div class="customMultiselect ml-0 mt-3"
                                    v-if="storeProductDropdown.options.length && compareData.primaryProductInfo.showProductDropdownPrimary">
                                    <div class="mb-1 ml-1" style="font-size:14px; font-weight:400; color:#1E1E1E">
                                        Product
                                        Name
                                    </div>
                                    <treeselect v-model="compareData.primaryProductInfo.selectedPrimaryProduct"
                                        :show-count="true"
                                        @select="(sku) => getDyamicProductDataOnChangeInput(sku, cardIndex, null, 'primary')"
                                        :options="storeProductDropdown.options" value-consists-of="LEAF_PRIORITY"
                                        :disable-branch-nodes="true" placeholder="Select Product Name"
                                        :searchable="true">
                                        <span slot="noResult">Oops! No elements found. Consider changing the search
                                            query.</span>
                                    </treeselect>
                                </div>
                                <div v-if="storeProductDropdown.options.length === 0 && compareData.primaryProductInfo.showProductDropdownPrimary"
                                    class="text-danger mt-2">
                                    Oops! No products available for this category. Kindly select another category.
                                </div>
                            </div>
                            <div v-else
                                class="text-danger d-flex justify-content-center border border-danger rounded p-2 noData">
                                {{
                                    compareData.primaryProductInfo.noDataMessage }}</div>
                        </div>
                    </div>
                    <div class="pr-0 pl-0 d-flex scroll-container"
                        :class="[getSecondaryItemWidthClass(compareData.secondaryProductInfo.length)]">
                        <div v-for="(secondaryItems, secondaryItemsIndex) in compareData.secondaryProductInfo"
                            class="pl-0 px-2"
                            :class="[secondaryItemsIndex == 0 && secondaryItems.selectedSecondaryProduct == null ? 'col-12' : 'col-11']">
                            <div class="mb-3">
                                <div class="position-relative" v-if="secondaryItems.noDataMessage == null">
                                    <div v-if="storeProductDropdown.options.length && secondaryItems.data.length">
                                        <CompareProductWithChart
                                            :productSelectSku="secondaryItems.selectedSecondaryProduct"
                                            :productDropdown="storeProductDropdown.options"
                                            :getProductDataOnChangeInput="(sku) => getDyamicProductDataOnChangeInput(sku, cardIndex, secondaryItemsIndex, 'secondary')"
                                            :productType='secondaryItems.typeOfProduct'
                                            :productImage="secondaryItems.data[secondaryItems.data.length - 1].product_image"
                                            :storeProductInfo="secondaryItems" />
                                    </div>
                                    <div v-if="!secondaryItems.data.length"
                                        class="addNewBrand py-5 d-flex justify-content-center">
                                        <div @click="toggleProductSelectionDropdown(cardIndex, secondaryItemsIndex, 'secondary')"
                                            class="d-flex align-items-center justidy-content-center"
                                            style="cursor: pointer;">
                                            <div class="plus-icon">
                                                +
                                            </div>
                                            <div class="ml-3" style="font-size:16px; font-weight: 500;">
                                                Add Product
                                            </div>
                                        </div>
                                    </div>
                                    <div class="customMultiselect ml-0 mt-3"
                                        v-if="storeProductDropdown.options.length && secondaryItems.showProductDropdownSecondary">
                                        <div class="mb-1 ml-1" style="font-size:14px; font-weight:400; color:#1E1E1E">
                                            Product
                                            Name
                                        </div>
                                        <treeselect v-model="secondaryItems.selectedSecondaryProduct" :show-count="true"
                                            @select="(sku) => getDyamicProductDataOnChangeInput(sku, cardIndex, secondaryItemsIndex, 'secondary')"
                                            :options="storeProductDropdown.options" value-consists-of="LEAF_PRIORITY"
                                            :disable-branch-nodes="true" placeholder="Select Product Name"
                                            :searchable="true">
                                            <span slot="noResult">Oops! No elements found. Consider changing the search
                                                query.</span>
                                        </treeselect>
                                    </div>
                                    <div v-if="storeProductDropdown.options.length === 0 && secondaryItems.showProductDropdownSecondary"
                                        class="text-danger mt-2">
                                        Oops! No products available for this category. Kindly select another category.
                                    </div>
                                    <div v-if="checkShowAndHide(secondaryItemsIndex)"
                                        class="removeDynamicSeconadyCardBtn position-absolute"
                                        @click="removeDyamicCardFun(cardIndex, secondaryItemsIndex, 'secondary')">
                                        +
                                    </div>
                                </div>
                                <div v-else
                                    class="text-danger d-flex justify-content-center border border-danger rounded p-2 noData">
                                    {{
                                        secondaryItems.noDataMessage }}</div>
                            </div>

                        </div>
                        <div v-if="checkLengthOfDynamicCards('secondarySubArray', cardIndex)"
                            class="addMoreProductCompareIcon d-flex align-items-center justify-content-center mx-1"
                            @click="addMoreDynamicSecondaryItemsFun(cardIndex)">
                            <div class="plus-icon">
                                +
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="checkShowAndHide(cardIndex)" class="removeDynamicCardBtn position-absolute"
                    @click="removeDyamicCardFun(cardIndex, null, 'primary')">
                    +
                </div>
            </div>
        </div> -->

        <div v-if="addMoreDynamicCardBtn && checkLengthOfDynamicCards('mainArray', null)"
            class="addMoreProductCompareIcon d-flex justify-content-center mr-3" @click="addMoreDyamicCardFun">
            <div class="plus-icon">
                +
            </div>
        </div>

        <!-- modal to get view name -->
        <b-modal size="md" class="customModal" id="saveNewViewId" hide-footer
            style="z-index: 3000 !important; text-transform: capitalize" v-model="showModalForSaveView"
            title="Select View Name">
            <select @change="handleViewNameSelectionPopUp" v-model="viewNameCollection.selectedViewNameBeforeSaving"
                class="form-control selectModal text-capitalize">
                <option value="" disabled hidden class="text-capitalize">choose One</option>
                <option v-for="d in viewNameCollection.options" :value="d" :key="d" class="text-capitalize">
                    {{ d }}
                </option>
                <option value="add_new" class="text-capitalize">Add New</option>
            </select>
            <div v-if="viewNameCollection.selectedViewNameBeforeSaving === 'add_new'" class="mt-3 d-flex">
                <input @input="capitalizeFirstLetter" v-model="viewNameCollection.newViewNameBeforeSaving"
                    placeholder="Enter View Name" type="text" class="customInput pl-2" />
            </div>
            <div class="d-flex justify-content-end align-items-center mt-3">
                <button class="btn saveViewBtn" :disabled="saveViewPostLoader" @click="savedViewPostApiCall">
                    <b-spinner small class="mr-2" v-if="saveViewPostLoader"></b-spinner>
                    <span>Save View</span>
                </button>
            </div>
        </b-modal>

        <!-- modal to change name -->
        <b-modal size="md" class="customModal" id="changeViewNameId" hide-footer
            style="z-index: 3000 !important; text-transform: capitalize" v-model="showModalForEditName"
            title="Change Current View Name">
            <div class="mt-3 d-flex">
                <input @input="capitalizeFirstLetterForEdit" v-model="editViewNameValue"
                    placeholder="Enter New View Name" type="text" class="customInput pl-2" />
            </div>
            <div class="d-flex justify-content-end align-items-center mt-3">
                <button class="btn saveViewBtn" :disabled="editNameLoader" @click="editNameApiCall">
                    <b-spinner small class="mr-2" v-if="editNameLoader"></b-spinner>
                    <span>Save Changes</span>
                </button>
            </div>
        </b-modal>

        <!-- delete confirmation for a view -->
        <b-modal title="Delete View" v-model="deleteViewModalValue" class="container-modal-ASIN">
            <div class="modal-delete-content d-flex align-items-start mb-2">
                <div class="delete-alert text-center rounded-circle px-2 mr-3">&#9888;</div>
                <div>You're going to delete this View from the View List.<br>Are you sure ?</div>
            </div>
            <div class="d-flex justify-content-end">
                <b-button @click="closeConfirmViewModal" class="btn primarycolor">No, Keep It.</b-button>
                <button @click="deleteParticularViewFun" :disabled="deleteParticularViewLoader"
                    class="btn primarycolor px-3 py-1 ml-2 d-flex align-items-center delete-viewBtn"
                    style="background-color: var(--red)">
                    <b-spinner small class="mr-2" v-if="deleteParticularViewLoader"></b-spinner>
                    <span>Yes, Delete!</span>
                </button>
            </div>
        </b-modal>
    </div>



</template>

<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import Multiselect from "vue-multiselect";
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import CompareProductWithChart from "../compareProductWithChart/CompareProductWithChart.vue";
import Loader from "../Components/Loader.vue";


export default {
    name: "PriceTrackingCompare",
    components: {
        Datepicker,
        Multiselect,
        Treeselect,
        CompareProductWithChart,
        Loader
    },
    data: function () {
        return {
            // showbrandNew: false,
            data: {},
            moment: moment,
            timestamp: moment().subtract(8, "days").format("YYYY-MM-DD"),
            timestamp2: moment().subtract(1, "days").format("YYYY-MM-DD"),
            dateRange: {
                startDate: moment().subtract(1, 'week').format("YYYY-MM-DD"),
                endDate: moment().format("YYYY-MM-DD")
            },
            backupDateRange: {
                startDate: moment().subtract(1, 'week').format("YYYY-MM-DD"),
                endDate: moment().format("YYYY-MM-DD")
            },
            maxDate: new Date(),
            minDate: new Date(moment().subtract(1, 'month')),
            timestamp2: moment().add(1, 'days').format('YYYY-MM-DD'),
            // timestamp1Disabled: {
            //     to: "",
            //     from: "",
            // },
            // timestamp2Disabled: {
            //     to: "",
            //     from: "",
            // },
            // catOptions: [],
            loader0: false,
            loader: false,
            // loader1: false,
            loaderPinList: false,
            loader1: false,
            loader3: false,
            // selectedCat: "",
            // schKey: "",
            // dataFull: {},
            // chartData: [],
            selectedPlatform: [],
            platformColor: {
                // flipkart: "#2874f0",
                // amazon: "#83c42a",
                // amazon_retail: "#FF9900",
                // jiomart: "#FD5542",
                // bigbasket: "#666872",
                // blinkit: "rgb(248, 203, 70)",
            },
            platformForRR: {
                amazon_retail: "#83c42a",
                flipkart: "#2874f0",
                blinkit: "rgb(248, 203, 70)"
            },
            locationDropdown: {
                options: '',
                checkSelectedPins: '',
                selectedPin: [],
            },

            segmentDropdown: {
                options: '',
                selectedSegment: ""
            },
            isSegment: '',
            client: JSON.parse(localStorage.reviewUserData).data.client,
            // selectedExportButton: '20SKU',
            // isDropdown: false,
            lastUpdated: `${moment().format("YYYY-MM-DD")} 11:00 AM`,
            // refreshFilterState: "",
            // isSelectedSegment: true,
            // swapped: false,
            // storeLineData: [],
            // procedTrandLineData: { xAxis: [] },
            allPlaformSelectedBoolean: true,
            storeAllPlatformsForMultipleSelection: [],
            getProductsLoader: false,






            storeProductDropdown: {
                options: '',
            },
            productSelectionDrapdown: false,
            primaryProductLoader: false,
            secondaryProductLoader: false,
            dynamicCompareCards: [
                {
                    primaryProductInfo: {
                        productName: '',
                        data: '',
                        finalTrendLine: '',
                        typeOfProduct: 'Primary Product',
                        noDataMessage: null,
                        selectedPrimaryProduct: null,
                        showProductDropdownPrimary: false,
                        productOffers: []
                    },
                    secondaryProductInfo: [
                        {
                            productName: '',
                            data: '',
                            finalTrendLine: '',
                            typeOfProduct: 'Competitor Product',
                            noDataMessage: null,
                            selectedSecondaryProduct: null,
                            showProductDropdownSecondary: false,
                            productOffers: []
                        },
                    ]
                }
            ],
            loderForDynamicData: false,
            platformFilterChanged: false,
            addMoreDynamicCardBtn: false,
            addMoreDynamicSecondaryBtn: false,
            saveViewPostLoader: false,
            saveViewGetLoader: false,
            viewNameCollection: {
                selectedViewName: '',
                options: [],
                selectedViewNameBeforeSaving: '',
                newViewNameBeforeSaving: null,
                storeDeleteViewId: []
            },
            showModalForSaveView: false,
            storeFullResponseOfTheView: [],
            showModalForEditName: false,
            editViewNameValue: null,
            editNameLoader: false,
            deleteViewModalValue: false,
            deleteParticularViewLoader: false,
            crossIconBtnValue: true
        };
    },




    mounted() {
        this.dataAPIs()
    },

    methods: {
        //corrected
        dataAPIs() {
            this.getLastUpdatedDates();
        },

        getSecondaryItemWidthClass(itemCount) {
            if (itemCount === 1) return 'col-6'; // Full width for one item
            if (itemCount === 2) return 'col-6';  // 50% width for two items
            return 'col-6';
        },

        // corrected
        getLastUpdatedDates() {
            this.loader = true;
            const url = `/api/v2/india_clients/last_update?client=${this.client}`;
            this.$http.get(url).then(
                (response) => {
                    if (response.body.data.price_tracking) {
                        localStorage.price_tracking_last_update = JSON.stringify(response.body.data.price_tracking);
                        this.dateRange.endDate = moment(response.body.data.price_tracking.end_date).format("YYYY-MM-DD");
                        this.dateRange.startDate = moment(response.body.data.price_tracking.end_date).subtract(1, 'week').format("YYYY-MM-DD");
                        this.backupDateRange.endDate = moment(response.body.data.price_tracking.end_date).format("YYYY-MM-DD");
                        this.backupDateRange.startDate = moment(response.body.data.price_tracking.end_date).subtract(1, 'week').format("YYYY-MM-DD");
                        this.maxDate = new Date(response.body.data.price_tracking.end_date);
                        this.minDate = new Date(response.body.data.price_tracking.start_date);
                        this.lastUpdated = `${moment(
                            response.body.data.price_tracking.end_date
                        ).format("DD MMM, YYYY")} ${response.body.data.price_tracking.latest_time ? "at" : ""}
                        ${response.body.data.price_tracking.latest_time}`;
                        this.$store.dispatch("DemoStore/setTimeStamp", this.lastUpdated);

                    }
                    this.loader = false;
                    this.getSegmentListData(); // for category and platform data
                    this.getPinListData() // for pincode data
                },
                (err) => {
                    this.loader = false;
                    console.log("err");
                }
            );
        },

        setDateRangeLastUpdated() {
            let storeLastUpdated = JSON.parse(localStorage.price_tracking_last_update);
            if (this.selectedPlatform.length == 1) {
                this.dateRange.endDate = moment(storeLastUpdated[this.selectedPlatform[0]].end_date).format("YYYY-MM-DD");
                this.dateRange.startDate = moment(storeLastUpdated[this.selectedPlatform[0]].end_date).subtract(1, 'week').format("YYYY-MM-DD");
                this.backupDateRange.endDate = moment(storeLastUpdated[this.selectedPlatform[0]].end_date).format("YYYY-MM-DD");
                this.backupDateRange.startDate = moment(storeLastUpdated[this.selectedPlatform[0]].end_date).subtract(1, 'week').format("YYYY-MM-DD");
                this.maxDate = new Date(storeLastUpdated[this.selectedPlatform[0]].end_date);
                this.minDate = new Date(storeLastUpdated[this.selectedPlatform[0]].start_date);
                this.lastUpdated = `${moment(storeLastUpdated[this.selectedPlatform[0]].end_date).format("DD MMM, YYYY")} ${storeLastUpdated[this.selectedPlatform[0]].latest_time ? "at" : ""}
                        ${storeLastUpdated[this.selectedPlatform[0]].latest_time}`;
                this.$store.dispatch("DemoStore/setTimeStamp", this.lastUpdated);
                console.log('length 1')
            } else {
                this.dateRange.endDate = moment(storeLastUpdated.end_date).format("YYYY-MM-DD");
                this.dateRange.startDate = moment(storeLastUpdated.end_date).subtract(1, 'week').format("YYYY-MM-DD");
                this.backupDateRange.endDate = moment(storeLastUpdated.end_date).format("YYYY-MM-DD");
                this.backupDateRange.startDate = moment(storeLastUpdated.end_date).subtract(1, 'week').format("YYYY-MM-DD");
                this.maxDate = new Date(storeLastUpdated.end_date);
                this.minDate = new Date(storeLastUpdated.start_date);
                this.lastUpdated = `${moment(storeLastUpdated.end_date).format("DD MMM, YYYY")} ${storeLastUpdated.latest_time ? "at" : ""}
                        ${storeLastUpdated.latest_time}`;
                this.$store.dispatch("DemoStore/setTimeStamp", this.lastUpdated);
                console.log('length 1 above')
            }
        },


        showModalForSaveViewFun() {
            this.showModalForSaveView = true;
        },


        checkSecondaryProductLength(check1, check2, length) {
            return check1 !== null && check2 != null
        },

        // don't remove it 
        // swapPrimarySecondary(index) {
        //     let card = this.dynamicCompareCards[index];
        //     const hasPrimaryData = card.primaryProductInfo.data.length !== 0;
        //     const hasSecondaryData = card.secondaryProductInfo.data.length !== 0;
        //     if (hasPrimaryData && hasSecondaryData) {
        //         [card.primaryProductInfo.selectedPrimaryProduct, card.secondaryProductInfo.selectedSecondaryProduct] =
        //             [card.secondaryProductInfo.selectedSecondaryProduct, card.primaryProductInfo.selectedPrimaryProduct];
        //         [card.primaryProductInfo, card.secondaryProductInfo] =
        //             [card.secondaryProductInfo, card.primaryProductInfo];
        //         this.processTrendLineGraphForDynamicCards(card.primaryProductInfo.data, index, 'primary');
        //         this.processTrendLineGraphForDynamicCards(card.secondaryProductInfo.data, index, 'secondary');
        //     } else {
        //         console.log('No trendline data is available to swap');
        //     }
        // },


        // corrected
        applyFilterForCompare() {
            this.getAllProductListAccordingToPlatforms(false);
            if (this.dynamicCompareCards.length > 0) {
                this.dynamicCompareCards.forEach((cardData, cardIndex) => {
                    if (cardData.primaryProductInfo && cardData.primaryProductInfo.selectedPrimaryProduct) {
                        this.getAllGraphDataBySku(cardData.primaryProductInfo.selectedPrimaryProduct, cardIndex, null, 'primary');
                    }

                    cardData.secondaryProductInfo.forEach((secondaryItems, secondaryIndex) => {
                        if (secondaryItems && secondaryItems.selectedSecondaryProduct) {
                            this.getAllGraphDataBySku(secondaryItems.selectedSecondaryProduct, cardIndex, secondaryIndex, 'secondary');
                        }
                    })

                })
            }
        },

        handleViewNameSelectionPopUp() {
            this.viewNameCollection.newViewNameBeforeSaving = null;
            this.addMoreDynamicCardBtn = false;
        },

        // corrected
        getSegmentListData() {
            let self = this;
            this.loader0 = true;
            let payload = {
                client: this.client,
                timestamp: moment(this.dateRange.endDate).format("YYYY-MM-DD")
            };
            const url = "/api/v2/india_clients/pincode_category";
            self.$http.post(url, payload).then(
                (response) => {
                    self.segmentDropdown.options = response.data.data.data
                    self.segmentDropdown.selectedSegment = ''
                    self.isSegment = response.data.data.is_segment
                    this.platformColor = response.data.data.platforms
                    this.getAllPlatformsList()
                    this.setAllPlatformsFun()
                    this.saveViewGetApiCall()
                    self.getAllProductListAccordingToPlatforms(true);
                    self.loader0 = false;

                },
                (err) => {
                    self.loader0 = false;
                    console.log("err");
                }
            );
        },

        // corrected
        getPinListData() {
            let self = this;
            self.loaderPinList = true;
            let payload = {
                timestamp: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
                client: this.client,
            };
            if (self.selectedPlatform == "") {
                payload.platform = []
            } else {
                payload.platform = self.selectedPlatform;
            }
            // const url = "/api/india_client/pincode_list";
            const url = "/api/v2/india_client/pincode_list"
            self.$http.post(url, payload).then(
                (response) => {
                    this.locationDropdown.options = response.data.data
                    if (this.locationDropdown.options.length) {
                        this.locationDropdown.checkSelectedPins = this.locationDropdown.options[0].children[0].children[0].id;
                    }
                    self.loaderPinList = false;
                }).catch((err) => {
                    self.loaderPinList = false;
                    console.log("err");
                })
        },

        // corrected
        getAllProductListAccordingToPlatforms(value) {
            let self = this;
            self.getProductsLoader = true;
            let payload = {
                platforms: self.selectedPlatform,
                category: self.segmentDropdown.selectedSegment,
            }

            let url = "/api/v2/indian_clients/product_filter"

            self.$http.post(url, payload).then((res) => {
                self.storeProductDropdown.options = []
                self.storeProductDropdown.options = res.data.data
                self.getProductsLoader = false;
                self.platformFilterChanged = false;
            }).catch((err) => {
                console.log(err)
                self.getProductsLoader = false;
            })
        },

        // for multiple platform selection //corrected
        setAllPlatformsFun() {
            this.selectedPlatform = [];
            this.storeAllPlatformsForMultipleSelection.forEach(items => {
                this.selectedPlatform = [...this.selectedPlatform, items];
            })
            this.getPinListData()
        },

        // corrected
        selectPlatformsForAllList() {
            this.allPlaformSelectedBoolean = !this.allPlaformSelectedBoolean;
            this.selectedPlatform = [];
            if (this.allPlaformSelectedBoolean) {
                this.storeAllPlatformsForMultipleSelection.forEach(items => {
                    this.selectedPlatform = [...this.selectedPlatform, items];
                })
            }
            this.setDateRangeLastUpdated();
            this.getPinListData()
        },

        // corrected
        getAllPlatformsList() {
            let storePlatformModifiedList = [];
            Object.keys(this.platformColor).forEach((items) => {
                storePlatformModifiedList.push(items);
            })

            this.storeAllPlatformsForMultipleSelection = storePlatformModifiedList;
            this.getPinListData()
        },

        // corrected
        changeSelectInput() {
            let length = 0;
            console.log(length)
            this.storeAllPlatformsForMultipleSelection.forEach(items => {
                length += 1;
            })

            if (length === this.selectedPlatform.length) {
                this.allPlaformSelectedBoolean = true;
            } else {
                this.allPlaformSelectedBoolean = false;
            }
            this.platformFilterChanged = true;

            this.setDateRangeLastUpdated()

            this.getPinListData();
        },

        // corrected
        formatKeyName(key) {
            return key
                .replace(/_/g, ' ')
                .replace(/\b\w/g, char => char.toUpperCase());
        },


        getColorForKey(key) {
            let updateKey = key.toLowerCase().replace(' ', '_');
            return this.platformColor[updateKey] || '#333';
        },

        // showProductSelectionFun() {
        //     this.productSelectionDrapdown = true;
        // },

        // corrected
        processTrendLineGraphForDynamicCards(data, cardIndex, secondaryItemsIndex, productType) {
            let seriesData = [];
            let xAxisData = [];

            // Process the trendline data
            data.forEach((items) => {
                xAxisData.push(moment(items.date).format("DD MMM"));
                const processedSeries = new Set();

                items.price.forEach((priceData) => {
                    const processedName = priceData.name.replace(/_/g, " ");
                    if (!processedSeries.has(processedName)) {
                        let series = seriesData.find(s => s.name === processedName);

                        if (!series) {
                            series = {
                                name: processedName,
                                color: this.getColorForKey(processedName), 
                                tooltip: {
                                    enabled: false,
                                    valuePrefix: '₹',
                                    formatter: function () {
                                        // const formattedName = this.series.name.toUpperCase();
                                        // return `${formattedName}: ₹${this.y.toLocaleString()}`;
                                    },
                                },
                                marker: {
                                    enabled: true,
                                    lineWidth: 3,
                                    fillColor: "#fff",
                                    // fillColor: this.getColorForKey(priceData.name),
                                    lineColor: this.getColorForKey(processedName),
                                    radius: 4,
                                    // states: {
                                    //     hover: {
                                    //         radiusPlus: 4.1,
                                    //         lineWidthPlus: 3.1,
                                    //     },
                                    // },
                                    symbol: 'circle'
                                },

                                dataLabels: {
                                    enabled: false,
                                    allowOverlap: true,
                                    style: { fontWeight: 'medium' },
                                    formatter: function () {
                                        return "₹" + this.point.y.toLocaleString();
                                    },
                                },
                                data: []
                            };
                            seriesData.push(series);
                        }
                        series.data.push(priceData.value);
                        processedSeries.add(processedName);
                    }

                });
            });

            if (productType == 'primary') {
                this.dynamicCompareCards[cardIndex].primaryProductInfo.finalTrendLine = {
                    id: `TrendLineGraphPrimary_${cardIndex}`,
                    xAxis: xAxisData,
                    seriesData: seriesData,
                    yAxisTitle: "Price(₹)"
                }
            } else if (productType == 'secondary') {
                this.dynamicCompareCards[cardIndex].secondaryProductInfo[secondaryItemsIndex].finalTrendLine = {
                    id: `TrendLineGraphSecondary_${cardIndex}_${secondaryItemsIndex}`,
                    xAxis: xAxisData,
                    seriesData: seriesData,
                    yAxisTitle: "Price(₹)"
                };
            }
        },

        // getColorForKey(key) {
        //     return this.platformColor[key] || '#333';
        // },

        // corrected
        addMoreDyamicCardFun() {
            this.dynamicCompareCards.push({
                primaryProductInfo: {
                    productName: '',
                    data: '',
                    finalTrendLine: '',
                    typeOfProduct: 'Primary Product',
                    noDataMessage: null,
                    selectedPrimaryProduct: null,
                    showProductDropdownPrimary: false,
                    productOffers: []
                },
                secondaryProductInfo: [
                    {
                        productName: '',
                        data: '',
                        finalTrendLine: '',
                        typeOfProduct: 'Competitor Product',
                        noDataMessage: null,
                        selectedSecondaryProduct: null,
                        showProductDropdownSecondary: false,
                        productOffers: []
                    },
                ]
            })
            this.productSelectionDrapdown = true;
            this.addMoreDynamicCardBtn = false

        },

        //  corrected
        scrollToRight(cardIndex) {
            this.$nextTick(() => {
                const container = document.querySelectorAll('.scroll-container')[cardIndex];
                if (container) {
                    container.scrollLeft = container.scrollWidth;
                    console.log(`Scrolled to right for card ${cardIndex}:`, container.scrollLeft);
                }
            });
        },

        // corrected
        addMoreDynamicSecondaryItemsFun(getCardIndex) {
            this.dynamicCompareCards[getCardIndex].secondaryProductInfo.push({
                productName: '',
                data: '',
                finalTrendLine: '',
                typeOfProduct: 'Competitor Product',
                noDataMessage: null,
                selectedSecondaryProduct: null,
                showProductDropdownSecondary: false,
                productOffers: []
            })
            this.productSelectionDrapdown = true;
            this.addMoreDynamicCardBtn = false
            this.scrollToRight(getCardIndex)
        },


        // corrected
        removeDyamicCardFun(getIndexValueForCards, getIndexValueForSecondaryCards, getProductType) {
            if (getProductType == 'primary') {
                if (this.dynamicCompareCards.length - 1 == getIndexValueForCards) {
                    this.addMoreDynamicCardBtn = true;
                } else {
                    if (this.dynamicCompareCards[getIndexValueForCards + 1] && this.dynamicCompareCards[getIndexValueForCards + 1].primaryProductInfo.selectedPrimaryProduct == null) {
                        this.addMoreDynamicCardBtn = false;
                    }
                }
                this.dynamicCompareCards.splice(getIndexValueForCards, 1);
            } else if (getProductType == 'secondary') {
                if (this.dynamicCompareCards[getIndexValueForCards].secondaryProductInfo.length - 1 == getIndexValueForSecondaryCards) {
                    this.addMoreDynamicCardBtn = true;
                }
                if (this.dynamicCompareCards[getIndexValueForCards + 1] && this.dynamicCompareCards[getIndexValueForCards + 1].secondaryProductInfo.some((items) => items.selectedSecondaryProduct == null)) {
                    this.addMoreDynamicCardBtn = false;
                }
                this.dynamicCompareCards[getIndexValueForCards].secondaryProductInfo.splice(getIndexValueForSecondaryCards, 1)
            }

            this.dynamicCompareCards.forEach((card, cardIndex) => {
                if (card.primaryProductInfo.data) {
                    this.processTrendLineGraphForDynamicCards(card.primaryProductInfo.data, cardIndex, null, 'primary');
                }
                card.secondaryProductInfo.forEach((secondaryItems, secondaryIndex) => {
                    if (secondaryItems.data) {
                        this.processTrendLineGraphForDynamicCards(secondaryItems.data, cardIndex, secondaryIndex, 'secondary');
                    }
                    this.scrollToRight(cardIndex)
                })
            });

        },
        // corrected
        getDyamicProductDataOnChangeInput(getUpdatedSkuAndLabel, cardIndex, secondaryItemsIndex, productType) {
            if (productType == 'primary') {
                this.dynamicCompareCards[cardIndex].primaryProductInfo.selectedPrimaryProduct = getUpdatedSkuAndLabel.id;
                this.dynamicCompareCards[cardIndex].primaryProductInfo.productName = getUpdatedSkuAndLabel.label;

                this.getAllGraphDataBySku(this.dynamicCompareCards[cardIndex].primaryProductInfo.selectedPrimaryProduct, cardIndex, null, productType);

                this.dynamicCompareCards[cardIndex].primaryProductInfo.showProductDropdownPrimary = false;

                this.scrollToRight(cardIndex);

            } else if (productType == 'secondary') {
                this.dynamicCompareCards[cardIndex].secondaryProductInfo[secondaryItemsIndex].selectedSecondaryProduct = getUpdatedSkuAndLabel.id;
                this.dynamicCompareCards[cardIndex].secondaryProductInfo[secondaryItemsIndex].productName = getUpdatedSkuAndLabel.label;

                this.getAllGraphDataBySku(this.dynamicCompareCards[cardIndex].secondaryProductInfo[secondaryItemsIndex].selectedSecondaryProduct, cardIndex, secondaryItemsIndex, productType);

                this.dynamicCompareCards[cardIndex].secondaryProductInfo[secondaryItemsIndex].showProductDropdownSecondary = false;

                this.scrollToRight(cardIndex);
            }
            if (this.dynamicCompareCards[this.dynamicCompareCards.length - 1].primaryProductInfo.selectedPrimaryProduct != null && this.dynamicCompareCards[this.dynamicCompareCards.length - 1].secondaryProductInfo.some((item) => item.selectedSecondaryProduct != null)) {

                this.addMoreDynamicCardBtn = true;
            }
        },
        // corrected
        getAllGraphDataBySku(productSku, cardIndex, secondaryItemsIndex, productType) {
            let self = this;
            self.loderForDynamicData = true
            self.getAllOffersApi(productSku, cardIndex, secondaryItemsIndex, productType);
            if (self.loderForDynamicData) {
                if (productType == 'primary') {
                    self.dynamicCompareCards[cardIndex].primaryProductInfo.noDataMessage = 'No Data Available.';
                } if (productType == 'secondary' && secondaryItemsIndex !== null) {
                    self.dynamicCompareCards[cardIndex].secondaryProductInfo[secondaryItemsIndex].noDataMessage = 'No Data Available.';
                }
            }
            let payload = {
                start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
                end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
                sku: productSku,
                pincode: self.locationDropdown.checkSelectedPins,
                platforms: self.selectedPlatform,
                category: self.segmentDropdown.selectedSegment
            }

            let url = "/api/v2/indian_clients/price_tracking/product"

            self.$http.post(url, payload).then((res) => {
                if (res.data.data.length) {
                    if (productType === 'primary') {
                        self.dynamicCompareCards[cardIndex].primaryProductInfo.data = res.data.data;
                        self.processTrendLineGraphForDynamicCards(self.dynamicCompareCards[cardIndex].primaryProductInfo.data, cardIndex, null, productType);
                        self.dynamicCompareCards[cardIndex].primaryProductInfo.noDataMessage = null;
                    } else if (productType === 'secondary' && secondaryItemsIndex !== null) {
                        self.dynamicCompareCards[cardIndex].secondaryProductInfo[secondaryItemsIndex].data = res.data.data;
                        self.processTrendLineGraphForDynamicCards(self.dynamicCompareCards[cardIndex].secondaryProductInfo[secondaryItemsIndex].data, cardIndex, secondaryItemsIndex, productType);
                        console.log(self.dynamicCompareCards[cardIndex].secondaryProductInfo[secondaryItemsIndex].data, cardIndex, secondaryItemsIndex, productType, 'kk')
                        self.dynamicCompareCards[cardIndex].secondaryProductInfo[secondaryItemsIndex].noDataMessage = null;
                    }
                }
                else {
                    if (productType === 'primary') {
                        if (cardIndex !== self.dynamicCompareCards.length - 1) {
                            self.dynamicCompareCards[cardIndex].primaryProductInfo.noDataMessage = 'No Data Available.';
                        }

                        if (self.dynamicCompareCards[self.dynamicCompareCards.length - 1].primaryProductInfo.selectedPrimaryProduct !== null) {
                            self.dynamicCompareCards[self.dynamicCompareCards.length - 1].primaryProductInfo.noDataMessage = 'No Data Available.';
                        }

                    } else if (productType === 'secondary' && secondaryItemsIndex !== null) {
                        if (cardIndex !== self.dynamicCompareCards.length - 1) {
                            self.dynamicCompareCards[cardIndex].secondaryProductInfo[secondaryItemsIndex].noDataMessage = 'No Data Available.';
                        }

                        if (self.dynamicCompareCards[self.dynamicCompareCards.length - 1].secondaryProductInfo[secondaryItemsIndex].selectedSecondaryProduct !== null) {
                            self.dynamicCompareCards[self.dynamicCompareCards.length - 1].secondaryProductInfo[secondaryItemsIndex].noDataMessage = 'No Data Available.';
                        }

                    }
                }
                self.loderForDynamicData = false;
            }).catch((err) => {
                console.log(err);
                self.loderForDynamicData = false;
            })

        },

        // corrected
        toggleProductSelectionDropdown(cardIndex, secondaryItemsIndex, productType) {
            if (productType == 'primary') {
                this.dynamicCompareCards[cardIndex].primaryProductInfo.showProductDropdownPrimary = !this.dynamicCompareCards[cardIndex].primaryProductInfo.showProductDropdownPrimary;
            } else if (productType == 'secondary') {
                this.dynamicCompareCards[cardIndex].secondaryProductInfo[secondaryItemsIndex].showProductDropdownSecondary = !this.dynamicCompareCards[cardIndex].secondaryProductInfo[secondaryItemsIndex].showProductDropdownSecondary;
            }

        },

        // corrected
        checkShowAndHide(getIndex) {
            return getIndex !== 0
        },

        changeViewNameByPencil(currentViewName) {
            this.showModalForEditName = true;
            this.editViewNameValue = currentViewName
        },

        editNameApiCall() {
            let self = this;
            self.editNameLoader = true;
            let findTheIdOfName = this.storeFullResponseOfTheView.find((oldName) => oldName.view_name == this.viewNameCollection.selectedViewName);
            if (findTheIdOfName) {
                let { page_filter, product_filter, view_id, view_name } = findTheIdOfName;
                const url = "/api/v2/reviews/comparison_view";
                let headers = {
                    Token:
                        "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoiMmIzYjAwMGI1YTk4NGU4ZWFjMjNjMjBjZDY1MWE0NzciLCJjbGllbnRfaWQiOiIxZTViMTFkNzFiZjg0ZWU3YWM1ODRkYjI3ZDQ1ODM4OSIsInRhcmdldF90aW1lIjoiMjAyNi0wOS0xMSAxNDo0ODowNC42MDExMzIiLCJhZG1pbiI6dHJ1ZX0.8_GtpOxfTBVpodGJKyJJ7PfjmG4msJNxcwbbyl9Xnpc",
                };
                let payload = {
                    view_for: "price_tracking",
                    view_data: {
                        product_filter: product_filter,
                        page_filter: page_filter,
                        view_name: self.editViewNameValue.trim(),
                    },
                    view_id: view_id
                };
                // console.log(findTheIdOfName, 'ddddddddddd')

                self.$http.post(url, payload).then((res) => {
                    this.$bvToast.toast('Saved this view', {
                        title: 'Price Tracking',
                        variant: 'success',
                        solid: true,
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 1000,
                        appendToast: true,
                    });
                    self.editNameLoader = false;
                    self.showModalForEditName = false;
                    self.saveViewGetApiCall();
                    self.viewNameCollection.selectedViewName = ""
                    self.addNewComparisonFun(true);
                }).catch((err) => {
                    console.log(err)
                    self.editNameLoader = false;
                })

            }
        },

        // corrected
        addNewComparisonFun(getValue) {
            let self = this;
            self.addMoreDynamicCardBtn = false;
            self.dynamicCompareCards = []
            self.dynamicCompareCards.push({
                primaryProductInfo: {
                    productName: '',
                    data: '',
                    finalTrendLine: '',
                    typeOfProduct: 'Primary Product',
                    noDataMessage: null,
                    selectedPrimaryProduct: null,
                    showProductDropdownPrimary: false,
                    productOffers: []
                },
                secondaryProductInfo: [
                    {
                        productName: '',
                        data: '',
                        finalTrendLine: '',
                        typeOfProduct: 'Competitor Product',
                        noDataMessage: null,
                        selectedSecondaryProduct: null,
                        showProductDropdownSecondary: false,
                        productOffers: []
                    },
                ]
            });
            this.viewNameCollection.selectedViewName = ""
            if (getValue) {
                self.segmentDropdown.selectedSegment = ""
                self.dateRange.startDate = self.backupDateRange.startDate;
                self.dateRange.endDate = self.backupDateRange.endDate;
                self.setAllPlatformsFun();

            }
            self.getAllProductListAccordingToPlatforms(false);
            this.setDateRangeLastUpdated();

        },
        // corrected
        checkLengthOfDynamicCards(getCheckValue, cardIndex) {
            if (getCheckValue == 'mainArray') {
                return this.dynamicCompareCards.length < 5;
            } else if (getCheckValue == 'secondarySubArray') {
                return this.dynamicCompareCards[cardIndex].secondaryProductInfo.length < 5 && this.dynamicCompareCards[cardIndex].secondaryProductInfo.every(product => product.selectedSecondaryProduct !== null);
            }
        },

        checkTheLengthOfSecondary(getLength) {
            if (getLength > 1) {
                return true;
            } else {
                return false;
            }
        },


        capitalizeFirstLetter(event) {
            const value = event.target.value;
            this.viewNameCollection.newViewNameBeforeSaving = value.replace(/\b\w/g, char => char.toUpperCase());
        },

        capitalizeFirstLetterForEdit(event) {
            const value = event.target.value;
            this.editViewNameValue = value.replace(/\b\w/g, char => char.toUpperCase());
        },

        // corrected
        goBack() {
            window.history.back();
        },

        // corrected
        savedViewPostApiCall() {
            let self = this;
            self.saveViewPostLoader = true;
            const url = "/api/v2/reviews/comparison_view";
            let getAllSkuList = [];


            let checkNameIsExsistOrNot = self.viewNameCollection.options.find((name) => name.trim() == self.viewNameCollection.newViewNameBeforeSaving);
            // console.log(checkNameIsExsistOrNot)
            // console.log(checkNameIsExsistOrNot, 'check data')
            if (checkNameIsExsistOrNot) {
                this.$bvToast.toast('This view name already exists.', {
                    title: 'Error',
                    variant: 'danger',
                    solid: true,
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 2000,
                    appendToast: true,
                });
                self.saveViewPostLoader = false;
                self.viewNameCollection.newViewNameBeforeSaving = null;
                return false;
            }

            if (self.viewNameCollection.selectedViewNameBeforeSaving == 'add_new' && !self.viewNameCollection.newViewNameBeforeSaving) {
                this.$bvToast.toast('Enter the view name.', {
                    title: 'Error',
                    variant: 'danger',
                    solid: true,
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 2000,
                    appendToast: true,
                });
                self.saveViewPostLoader = false;
                self.viewNameCollection.newViewNameBeforeSaving = null;
                return false;
            }

            let findViewId = self.storeFullResponseOfTheView.find((data) => data.view_name == self.viewNameCollection.selectedViewNameBeforeSaving);
            self.dynamicCompareCards.forEach((items) => {
                let secondaryDetailsData = []
                // if (items.primaryProductInfo.selectedPrimaryProduct != null && items.secondaryProductInfo.selectedSecondaryProduct != null) {
                //     getAllSkuList.push({
                //         primary: items.primaryProductInfo.selectedPrimaryProduct,
                //         secondary: items.secondaryProductInfo.selectedSecondaryProduct,
                //         primaryProductName: items.primaryProductInfo.productName,
                //         secondaryProductName: items.secondaryProductInfo.productName
                //     })
                // }
                items.secondaryProductInfo.forEach((secondaryItems) => {
                    if (items.primaryProductInfo.selectedPrimaryProduct != null && secondaryItems.selectedSecondaryProduct != null) {
                        secondaryDetailsData.push({
                            secondary: secondaryItems.selectedSecondaryProduct,
                            secondaryProductName: secondaryItems.productName
                        })

                    }
                })
                if (items.primaryProductInfo.selectedPrimaryProduct != null && secondaryDetailsData.length !== 0) {
                    getAllSkuList.push({
                        primary: items.primaryProductInfo.selectedPrimaryProduct,
                        primaryProductName: items.primaryProductInfo.productName,
                        secondaryDetails: secondaryDetailsData
                    })
                }

            })

            let payload = {
                view_for: "price_tracking",
                view_data: {
                    product_filter: getAllSkuList,
                    page_filter: {
                        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
                        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
                        category: self.segmentDropdown.selectedSegment,
                        pincode: self.locationDropdown.checkSelectedPins,
                        platforms: self.selectedPlatform
                    },
                    view_name: self.viewNameCollection.newViewNameBeforeSaving == null ? self.viewNameCollection.selectedViewNameBeforeSaving.trim() : self.viewNameCollection.newViewNameBeforeSaving.trim(),
                }
            };
            // console.log(findViewId,  self.viewNameCollection.newViewNameBeforeSaving ,'dddd')

            if (findViewId) {
                let { view_id } = findViewId
                payload.view_id = view_id;
                // console.log(view_id)
            }
            console.log(payload, 'payload for save view')

            self.$http.post(url, payload).then((res) => {
                this.$bvToast.toast('Saved this view', {
                    title: 'Price Tracking',
                    variant: 'success',
                    solid: true,
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 1000,
                    appendToast: true,
                });
                self.saveViewPostLoader = false;
                self.showModalForSaveView = false;
                self.saveViewGetApiCall();
            }).catch((err) => {
                console.log(err)
                self.saveViewPostLoader = false;
            })
        },

        //corrected
        saveViewGetApiCall() {
            // console.log('this')
            let self = this;
            self.saveViewGetLoader = true;
            const url = "/api/v2/reviews/comparison_view?view_for=price_tracking";

            self.$http.get(url).then((res) => {
                // res.data.data = []
                self.storeFullResponseOfTheView = [];
                self.viewNameCollection.options = [];
                if (res.data.data.length !== 0) {
                    let storeResponse = res.data.data;
                    self.storeFullResponseOfTheView = res.data.data;
                    storeResponse.forEach((viewName) => {
                        self.viewNameCollection.options.push(viewName.view_name);
                    })
                    console.log(res.data.data, 'get all view list')
                    self.saveViewGetLoader = false;
                }

                self.saveViewGetLoader = false;
            }).catch((err) => {
                console.log(err)
                self.saveViewGetLoader = false;
            })
        },

        // corrected
        getAllOffersApi(productSku, cardIndex, secondaryItemsIndex, productType) {
            let self = this;
            let url = 'api/v2/india_clients/product_offers_details';
            let payload = {
                pincode: self.locationDropdown.checkSelectedPins,
                timestamp: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
                sku: productSku,
                platforms: self.selectedPlatform
            }
            self.$http.post(url, payload).then((res) => {
                console.log(res)
                if (productType == 'primary') {
                    self.dynamicCompareCards[cardIndex].primaryProductInfo.productOffers = res.body.data;
                } if (productType == 'secondary') {
                    self.dynamicCompareCards[cardIndex].secondaryProductInfo[secondaryItemsIndex].productOffers = res.body.data;
                }
            }).catch(err => {
                console.log(err, 'err')
            })
        },

        //corrected >>>
        handleViewSelection() {
            let self = this;
            let selectedViewNamefromDropdown = self.viewNameCollection.selectedViewName;
            let getSingleObjByViewName = self.storeFullResponseOfTheView.find((data) => data.view_name == selectedViewNamefromDropdown);
            if (getSingleObjByViewName) {
                let { page_filter, product_filter } = getSingleObjByViewName;
                self.dynamicCompareCards = [];

                self.dateRange.startDate = page_filter.start_date;
                self.dateRange.endDate = page_filter.end_date;
                self.segmentDropdown.selectedSegment = page_filter.category;
                self.locationDropdown.checkSelectedPins = page_filter.pincode;
                self.selectedPlatform = page_filter.platforms

                // console.log(product_filter, 'pk')
                product_filter.forEach((items, cardIndex) => {
                    //    console.log(items, 'product_filter_item')
                    let getAllSecondaryProducts = [];
                    if (Array.isArray(items.secondaryDetails) && items.secondaryDetails.length > 0) {
                        items.secondaryDetails.forEach((item, secondaryItemsIndex) => {
                            // console.log(item, 'lp')
                            getAllSecondaryProducts.push({
                                productName: item.secondaryProductName,
                                data: '',
                                finalTrendLine: '',
                                typeOfProduct: 'Competitor Product',
                                noDataMessage: null,
                                selectedSecondaryProduct: item.secondary,
                                showProductDropdownSecondary: false,
                                productOffers: []
                            })
                            // console.log(getAllSecondaryProducts, 'lp2')

                            // if (item.secondary) {
                            //     this.getAllGraphDataBySku(item.secondary, cardIndex, secondaryItemsIndex, 'secondary')
                            // }
                            // console.log(item.secondary, cardIndex, secondaryItemsIndex, 'secondary')
                        })
                    }

                    this.dynamicCompareCards.push({
                        primaryProductInfo: {
                            productName: items.primaryProductName,
                            data: '',
                            finalTrendLine: '',
                            typeOfProduct: 'Primary Product',
                            noDataMessage: null,
                            selectedPrimaryProduct: items.primary,
                            showProductDropdownPrimary: false,
                            productOffers: []
                        },
                        secondaryProductInfo: getAllSecondaryProducts
                    });

                    if (items.primary) {
                        this.getAllGraphDataBySku(items.primary, cardIndex, null, 'primary');
                    }

                    if (Array.isArray(items.secondaryDetails) && items.secondaryDetails.length > 0) {
                        items.secondaryDetails.forEach((item, secondaryItemsIndex) => {
                            if (item.secondary) {
                                this.getAllGraphDataBySku(item.secondary, cardIndex, secondaryItemsIndex, 'secondary');
                            }
                        });
                    }

                    this.scrollToRight(cardIndex);

                });




                if (self.dynamicCompareCards.length < 5) {
                    self.dynamicCompareCards.push({
                        primaryProductInfo: {
                            productName: '',
                            data: '',
                            finalTrendLine: '',
                            typeOfProduct: 'Primary Product',
                            noDataMessage: null,
                            selectedPrimaryProduct: null,
                            showProductDropdownPrimary: false,
                            productOffers: []
                        },
                        secondaryProductInfo: [
                            {
                                productName: '',
                                data: '',
                                finalTrendLine: '',
                                typeOfProduct: 'Competitor Product',
                                noDataMessage: null,
                                selectedSecondaryProduct: null,
                                showProductDropdownSecondary: false,
                                productOffers: []
                            },
                        ]
                    });
                }

            }

            // console.log(this.dynamicCompareCards, getAllSecondaryProducts, 'harsh')

            this.addMoreDynamicCardBtn = false;
            // this.applyFilterForCompare();
            this.getAllProductListAccordingToPlatforms(false);
            this.$store.dispatch("DemoStore/setTimeStamp", '');

        },


        changedCategorty() {
            this.addNewComparisonFun(false)
        },



        closeConfirmViewModal() {
            this.deleteViewModalValue = false;
        },

        showViewDeleteModal() {
            this.viewNameCollection.storeDeleteViewId = [];
            this.deleteViewModalValue = true;
            let getDeletedObj = this.storeFullResponseOfTheView.find((items) => items.view_name == this.viewNameCollection.selectedViewName);
            let { view_id } = getDeletedObj;
            this.viewNameCollection.storeDeleteViewId.push(view_id)
        },

        // corrected
        deleteParticularViewFun() {
            let self = this;
            self.deleteParticularViewLoader = true;
            const url = "/api/v2/reviews/comparison_view";
            let payload = {
                view_id: self.viewNameCollection.storeDeleteViewId,
                view_for: "price_tracking"
            }


            self.$http.delete(url, { body: payload }).then((res) => {
                // console.log(res)
                self.saveViewGetApiCall();
                this.$bvToast.toast(res.data.summary, {
                    title: 'Price Tracking',
                    variant: 'success',
                    solid: true,
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 2000,
                    appendToast: true,
                });
                self.addNewComparisonFun(true)
                self.deleteParticularViewLoader = false;
            }).catch((err) => {
                console.log(err)
                self.deleteParticularViewLoader = false;
            })

            this.deleteViewModalValue = false;
        }

    },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.exportButton {
    margin-left: 6px;
    height: 35px;
    border: none;
    background: var(--primary_brand);
    color: white;
    border-radius: 5px;
    font-weight: 600;
    padding: 0px 25px;
    letter-spacing: 0.2px;
}

.lastUpdated {
    color: #065559;
    font-size: 12px;
    padding: 5px 10px;
    border: 1px solid var(--base_color-80);
    border-radius: 6px;
    height: 35px;
    display: flex;
    align-items: center;
}

.CustomDropdown {
    border: 1px solid rgb(172, 172, 172);
    z-index: 999999999 !important;
    margin-left: 5px;
    border-radius: 3px;
    margin-top: 2px;
    position: absolute;
    background: white;
    width: 200px;
    right: 12px;
}

.customItem {
    padding: 3px 5px 2px 8px;
    cursor: pointer;
    color: var(--primary_brand)
}

.customInput {
    border-radius: 5px !important;
    height: 35px !important;
    border: 1px solid #e4e7ea;
    width: 220px;
    outline: none;
    font-family: 'poppins';
    width: 100%
}

.customInput:focus {
    border: 1px solid var(--primary_brand) !important;
    box-shadow: none !important;
}

.customItem:hover {
    background: var(--primary_brand-10);
}

.chartOverflow {
    overflow-x: scroll;

}

.name {
    line-height: 28px;
    text-transform: capitalize;
    font-size: 14px;
    margin-left: 5px;
}

.value {
    font-size: 14px;
    line-height: 24px;
    margin-right: 5px;
}

.leftsticker {
    width: 65px;
    float: left;
    height: 54px;
    color: white;
    font-size: 37px;
    text-align: center;
}

.rightsticker {
    width: 100%;
    /* float: left; */
    background: white;
    display: flex !important;
    flex-direction: row !important;
    justify-content: space-between !important;
}

/* .card {
    margin-bottom: 8px;
} */

.card-body {
    padding: 0 !important;
    display: flex;
}

.card {
    border-radius: 0.7rem !important;
    border: none !important;
    margin-bottom: 1rem;
}

.productwrap {
    padding: 26px;
    padding-top: 6px;
    margin-top: 6px;
}

.swiggy_border {
    border-right: 2px solid #f5670e;
}

.zepto_border {
    border-right: 2px solid #d5b3ff;
}

.grofers_border {
    border-right: 2px solid #f15c2c !important;
}

.tatacliq_border {
    border-right: 2px solid #a9323f !important;
}

.bigbasket_border {
    border-right: 2px solid #666872 !important;
}

.blinkit_border {
    border-right: 2px solid rgb(248, 203, 70) !important;
}

.jiomart_border {
    border-right: 2px solid #fd5542 !important;
}

.tatacliq_border {
    border-right: 2px solid #a9323f !important;
}

.amazon_border {
    border-right: 2px solid #83c42a !important;
}

.amazon_retail_border {
    border-right: 2px solid #ff9900 !important;
}

.croma_border {
    border-right: 2px solid #49a7a1 !important;
}

.paytm_border {
    border-right: 2px solid #28bbf0 !important;
}

.snapdeal_border {
    border-right: 2px solid #f34741 !important;
}

.myntra_border {
    border-right: 2px solid #ec548b !important;
}

.vijaysales_border {
    border-right: 2px solid #ee4326 !important;
}

.ril_border {
    border-right: 2px solid #bfa161 !important;
}

.outofstock {
    color: red;
    float: right;
    font-size: 12px;
    margin-right: 5px;
    text-transform: capitalize;
}

.instock {
    color: var(--green);
    float: right;
    font-size: 12px;
    margin-right: 5px;
    text-transform: capitalize;
}

.flipkart_border,
.flipkart_grocery_border {
    border-right: 2px solid #2874f0 !important;
}

/* .card {
    border-radius: 0.7rem !important;
    border: none !important;
    margin-bottom: 1rem;
} */

.form-control {
    border-radius: 5px !important;
    padding: 6px !important;
    font-size: 12px !important;
    height: 35px !important;
    border: 1px solid var(--base_color-40) !important;
}

.customSelect {
    margin-inline: 0.5rem;
}

.customSelectExport {
    margin-inline: 0.5rem;

}

.customSelect :focus {
    background: var(--base_color-5);
    color: var(--primary_brand-60);
    border: 1px solid var(--primary_brand-60) !important;
    outline: none;
    box-shadow: none;
    font-weight: 600;
}

button.primarycolor {
    background: var(--primary_brand);
    font-family: "Poppins", sans-serif;
    color: white;
    padding: 7px 15px;
    border-radius: 6px;
    letter-spacing: 0.2px;
    font-weight: bold;
    font-size: 14px;
}

button.primarycolor:hover {
    color: white;
    background: var(--primary_brand-80);
    /* border: 1.6px solid var(--base_color); */
}

button.insights {
    background-color: #fab937;
    font-family: "Poppins", sans-serif;
    color: white;
    padding: 7px 20px;
    border-radius: 6px;
    letter-spacing: 0.2px;
    font-weight: bold;
    font-size: 14px;
}

button.insights:hover {
    background-color: #fac04c !important;
    color: white !important;
}

.graphHeading {
    font-weight: 600 !important;
    font-size: 16px !important;
    color: var(--primary_brand) !important;
    letter-spacing: 0.6px !important;
    font-family: "poppins";
}

#sovindia4page {
    font-family: "Poppins", sans-serif !important;
}

.btn-outline-secondary:not(:disabled):not(.disabled):active,
.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show>.btn-outline-secondary.dropdown-toggle {
    color: #ffffff !important;
    background-color: var(--primary_brand-80) !important;
    border-color: var(--primary_brand-80) !important;
    line-height: 35px !important;
    padding: 0px 20px !important;
    border-radius: 5px !important;
    font-weight: 600 !important;
}

.btn-outline-secondary {
    line-height: 35px !important;
    /* border-radius: 5px; */
    color: var(--primary_brand) !important;
    background: var(--primary_brand-10) !important;
    border: 1px solid var(--primary_brand-10) !important;
    font-family: "poppins" !important;
    padding: 0px 20px !important;
}

.btn-group {
    background: var(--primary_brand-10) !important;
    border-radius: 5px !important;
    font-family: "poppins" !important;

    /* border: 1px solid var(--primary_brand-10); */
}

.datePickerBadge {
    margin-left: 6px;
    height: 35px !important;
    border: 1px solid #c5c5c5;
    border-right: none;
    display: flex;
    align-items: center;
    margin-right: -5px;
    z-index: 3;
    background: #fff;
    color: black;
    border-radius: 5px 0px 0px 5px;
    font-family: "poppins";
}

.borderBetween {
    border-bottom: 0.13rem solid #e1e1e1 !important;
    margin: 7px 0px !important;
}

.navigationButton {
    height: 35px;
    border: none;
    margin: 0;
    background: var(--accent_color);
    color: white;
    border-radius: 5px;
    font-size: 14px;
    font-weight: bold;
    padding: 0px 20px;
    letter-spacing: 0.2px;
    font-family: "poppins";
}

.navigationButton:hover {
    background: var(--accent_color-80);
}

.inputBoxTitle {
    color: var(--primary_brand);
    font-size: 16px;
    margin-bottom: 5px;
    font-family: "poppins";
}

.productListCheckbox span {
    /* font-weight: 600; */
    font-family: "Poppins", sans-serif !important;
}

.eachProduct:hover {
    background: var(--base_color-20);
}
</style>
<style>
.vue-treeselect__control {
    height: 35px !important;
    border: 1px solid rgba(75, 75, 75, 0.4) !important;
    border-radius: 5px !important;
}

.vue-treeselect__multi-value {
    height: 30px !important;
    overflow: auto !important;
}

.vue-treeselect__multi-value-item {
    background-color: rgba(6, 85, 89, 1) !important;
    color: white !important;
}

.vue-treeselect__value-remove {
    color: white !important;
}

.customMultiselect .multiselect__placeholder {
    margin-bottom: 6px !important;
    padding: 0px !important;
    color: var(--primary_brand-40) !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__tags {
    border: 1px solid var(--base_color-40) !important;
    padding-top: 6px !important;
    min-height: 35px !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__select {
    min-height: 35px !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__select::before {
    top: 56% !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__tag {
    background: var(--primary_brand-80) !important;
    margin-bottom: 0px !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__tag-icon:after {
    color: #fff !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__content-wrapper {
    border: 1px solid var(--base_color-40) !important;
    border-top: none !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__option--selected.multiselect__option--highlight {
    background: var(--red) !important;
    color: var(--white) !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__option--highlight {
    background: var(--base_color-20) !important;
    color: var(--primary_brand-80) !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__element {
    color: var(--primary_brand-80) !important;
    border-bottom: 1px solid var(--base_color-20);
    font-family: "poppins";
}

/* width */
.customMultiselect ::-webkit-scrollbar {
    width: 10px;
    border-radius: 10px;
}

/* Track */
.customMultiselect ::-webkit-scrollbar-track {
    background: var(--base_color-20);
    border-radius: 10px;
}

/* Handle */
.customMultiselect ::-webkit-scrollbar-thumb {
    background: var(--base_color-80);
    border-radius: 10px;
}

/* Handle on hover */
.customMultiselect ::-webkit-scrollbar-thumb:hover {
    background: var(--base_color);
}

.customMultiselect .multiselect__input:focus {
    border: none !important;
    color: #000 !important;
    box-shadow: none;
}

.revampCard {
    border-radius: 0.7rem !important;
    border: none !important;
    margin: 10px;
    /* margin-bottom: 1rem; */
}

.noData {
    background: #fff7f7 !important;
}

.addNewBrand {
    border: 1px solid #D9D9D9;
    border-radius: 10px;
    /* box-shadow: 0 8px 24px rgba(149,157,165,.2); */
    box-shadow: rgba(14, 63, 126, 0.04) 0px 0px 0px 1px, rgba(42, 51, 69, 0.04) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.04) 0px 6px 6px -3px, rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 24px 24px -12px;
}

.addNewBrand>img {
    cursor: pointer;
    width: 100%;
    max-width: 180px;
}

.swapArrowsContainer {
    left: 50.5%;
    transform: translateX(-50.5%);
    top: 5%;
    background: #F2F6F6;
    border-radius: 50%;
    padding: 15px 17px;
    z-index: 1;
    cursor: pointer;
}

.crossBtn {
    top: 0px;
    right: 1px;
    font-size: 25px;
    cursor: pointer;
    width: 25px;
    height: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
}

.crossBtn:hover {
    background: #ff000014;
}

.addMoreProductCompareIcon {
    cursor: pointer;
}

.borderBetweenTab {
    border: 1px solid #D5D5D5;
}

#PriceTrackingCompare .vue-treeselect--single .vue-treeselect__option--selected {
    background: #44777a1a !important;
    font-weight: 600;
}

#PriceTrackingCompare .vue-treeselect__input-container>input:focus {
    box-shadow: none;
}



/* dynamic card */
.removeDynamicCardBtn {
    top: -10px;
    right: 0px;
    background: #DEDEDE;
    height: 30px;
    width: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    padding: 0;
    cursor: pointer;
    transform: rotate(45deg);
}

.removeDynamicCardBtn:hover {
    background: #0655591a;
}

.removeDynamicSeconadyCardBtn {
    top: 5px;
    right: 7px;
    background: #DEDEDE;
    height: 30px;
    width: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    padding: 0;
    cursor: pointer;
    transform: rotate(45deg);

}

.removeDynamicSeconadyCardBtn:hover {
    background: #0655591a;
}

.saveViewBtn {
    /* margin: 0px 0 0 10px; */
    height: 37px;
    border: none;
    background: var(--accent_color);
    /* border: 1px solid var(--primary_brand); */
    color: white;
    border-radius: 5px !important;
    font-weight: 600;
    letter-spacing: 0.2px;
    display: flex;
    align-items: center;
}

.saveViewBtn:hover {
    background: var(--accent_color-80);
    color: #fff;
}

button[disabled="disabled"] {
    cursor: not-allowed !important;
}

/* .selectModal option{
    padding: 10px 0;
} */

.graphHeading {
    font-weight: 600 !important;
    font-size: 20px !important;
    color: var(--primary_brand) !important;
    letter-spacing: .6px !important;
    font-family: poppins;
    margin-bottom: -20px !important;
}

.newComparisonIcon svg {
    height: 17px;
    transform: rotate(45deg);
    color: white;
    fill: #fff;
    margin-right: 5px;
}

.noData {
    background: #fff7f7 !important;
}

.viewNameEditBtn {
    cursor: pointer;
}

.navigationButton {
    height: 35px;
    border: none;
    margin: 0;
    background: var(--accent_color);
    color: white;
    border-radius: 5px;
    font-size: 14px;
    font-weight: bold;
    padding: 0px 18px;
    letter-spacing: 0.2px;
    font-family: "poppins";
}

.navigationButton:hover {
    background: var(--accent_color-80);
}

.delete-viewBtn:hover {
    background-color: #f58181 !important;
}

.delete-alert {
    background-color: #ffecec !important;
    color: var(--red);
    font-size: 30px;
    width: 45px;
    height: 45px;
}

.compareContainerCards {
    margin-left: 0 !important;
    margin-right: 0 !important;
}

.plus-icon {
    font-size: 30px;
    color: #5E5E5E;
    border: 2px dashed #5E5E5E;
    border-radius: 50%;
    padding-inline: 12px;
    cursor: pointer;
}

.scroll-container {
    overflow-x: auto !important;
    /* overflow-y: visible !important; */
}

.scroll-container::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(203, 203, 203, 0.3);
    border-radius: 6px;
    background: #EBEDEE;
}

.scroll-container::-webkit-scrollbar {
    height: 6px;
    width: 6px;
}

.scroll-container::-webkit-scrollbar-thumb {
    border-radius: 6px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background: #B3B2B9;
}

.scroll-container::-webkit-scrollbar-thumb:hover {
    background: #8B8D94;
    cursor: pointer;
}

.containerOverflowClass {
    width: 99.8%;
    overflow-x: visible !important;
}

/* #PriceTrackingCompare{
    overflow-x: visible;
 } */


.plus-icon:hover {
    background: #f0ededc7;
}
.customSelectedLabels .custom-tag {
  background: var(--primary_brand-80) !important;
  padding: 1px 0px 1px 10px;
  border-radius: 5px;
  margin-right: 5px;
  margin-bottom: 5px;
  display: inline-block !important;
  align-items: center !important;
  color: #fff !important;
}

.customSelectedLabels .custom-tag .remove-icon:hover{
  background-color: #369a6e;
  border-radius: 5px;
}

.customSelectedLabels .remove-icon {
  cursor: pointer;
  font-size: 14px;
  margin-left: 5px;
  color: #fff;
  font-weight: bold;
}
/* .col-12-new{
    flex: 0 0 95%;
    max-width: 95%;
} */


.point-compare {
    display: flex;
    flex-direction: column;
    /* justify-content: space-evenly; */
    z-index: 1;
    box-shadow: 0 8px 24px rgba(149, 157, 165, .2);
}

.compare-container-data-price .card {
    border: 1px solid #ebebeb !important;
    padding: 0 !important;
    margin-bottom: 0 !important;
}

.bgTopColor {
    background-color: rgba(6, 85, 89, .050980392156862744);
    height: 40px;
    border: 3px !important;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    /* margin: 0 -24px; */
}


.form-control:focus {
    box-shadow: none !important;
}

/* .bgTopColor::after {
    position: absolute;
    content: "";
    width: 24px;
    background-color: rgba(6, 85, 89, .050980392156862744);
    right: -24px;
    top: 0;
    bottom: 0;
} */

.col-sm-10-width {
    width: 86% !important;
}

.col-sm-12-width {
    width: 100% !important
}

.highcharts-tooltip text {
    text-transform: capitalize !important;
}
</style>
